import { createSelector } from 'reselect';
import DespatchMonitoringResponseAnalysisColumns from '../../containers/DespatchMonitoringResponseAnalysisColumns';
import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime =
  state => state.reporting.DESPATCH_MONITORING_RESPONSE_ANALYSIS.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.DESPATCH_MONITORING_RESPONSE_ANALYSIS.isLoading;

export const getData = ReportDefinitions.DESPATCH_MONITORING_RESPONSE_ANALYSIS.getDataFunction();

export const getColumns = createSelector(getData, DespatchMonitoringResponseAnalysisColumns);
